export default {"src":"/_next/static/media/design_services.fe1b23f4.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};